import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import moment from 'moment';
import {Card, Spin} from 'antd';
import {
  fetchMatrixDirections, fetchMatrixIvs, fetchtradingMatrixStrategies, fetchtradingMatrixTargetLists
}
  from '../../actions/tradeMatrix';
import {StyledContent} from '../../styles/mixins';
import {StyledTable, StyledLoadingDiv} from './style'

class TradeMatrix extends Component {

  state = {
    tradingMatrixDirections: [],
    tradingMatrixIvs: [],
    tradingMatrixStrategies: [],
    tradingMatrixTargetLists: [],
  }

  componentDidMount() {
    const user_uid = localStorage.getItem('user_uid')
    if (user_uid) {
      this.setState({
        isLoading: true,
      })
      Promise.all([
        fetchMatrixDirections(),
        fetchMatrixIvs(),
        fetchtradingMatrixStrategies(),
        fetchtradingMatrixTargetLists(),
      ]).then(data => {
        if (data && data.length) {
          const tradingMatrixDirections = (data[0].data && data[0].data.data && data[0].data.data.tradingMatrixDirections) || [];
          const tradingMatrixIvs = (data[1].data && data[1].data.data && data[1].data.data.tradingMatrixIvs) || [];
          const tradingMatrixStrategies = (data[2].data && data[2].data.data && data[2].data.data.tradingMatrixStrategies) || [];
          const tradingMatrixTargetLists = (data[3].data && data[3].data.data && data[3].data.data.tradingMatrixTargetLists) || [];
          this.setState({
            tradingMatrixDirections,
            tradingMatrixIvs,
            tradingMatrixStrategies,
            tradingMatrixTargetLists,
          });
        }
        this.setState({
          isLoading: false,
        })
      })
    }

  }

  getValues = (index, matrix, direction) => {
    const {tradingMatrixStrategies, tradingMatrixTargetLists} = this.state;
    const strategies = tradingMatrixStrategies.filter(x =>
      x.tradingMatrixIvs.find(t => t.name === matrix.name) &&
      x.tradingMatrixDirections.find(t => t.name === direction.name)
    )

    let symbols = tradingMatrixTargetLists.filter(x =>
      x.tradingMatrixIvs.find(t => t.name === matrix.name) &&
      x.tradingMatrixDirections.find(t => t.name === direction.name)
    )
    symbols = symbols.filter(x=>(
        (!x.startDate && !x.endDate) ||
        (!x.endDate && x.startDate && moment(x.startDate).isBefore(moment())) ||
        (x.startDate && x.endDate && moment(x.startDate).isBefore(moment()) && moment(x.endDate).isAfter(moment()))
    ))
    if (index === 1) {
      return (
        <td>
          <ul>
            {
              symbols.map(p => <li key={p.symbol} title={p.description}><Link to={`/stocks/${p.symbol}`}>{p.symbol}</Link></li>)
            }
          </ul>
        </td>
      )
    }

    return (
      <td className="strategy">
        <ul>
          {
            strategies.map(p => <li key={p.name}>{p.name}</li>)
          }
        </ul>
      </td>
    )
  }

  render() {
    const {tradingMatrixDirections = [], tradingMatrixIvs = [], isLoading} = this.state
    const directions = tradingMatrixDirections || [];
    return (
      <StyledContent>
        <Card title="Trade Matrix" bordered={false}>
          {isLoading ? <StyledLoadingDiv><Spin size="large"/></StyledLoadingDiv>
            :

            <StyledTable>
              <thead>
              <tr>
                {
                  directions.length &&
                  [{name: '-'}, ...directions].map(x => (<th key={x.name}>{x.name}</th>))
                }
              </tr>
              </thead>
              <tbody>
              {
                tradingMatrixIvs && tradingMatrixIvs.map(matrix => {
                  return [0, 1].map(count => (
                    <tr key={count}>
                      {
                        count === 0 ? <td className="matrix" rowSpan={2}>
                          <div><span>{matrix.name}</span></div>
                        </td> : null
                      }
                      {
                        directions.map(direction => {
                          return this.getValues(count, matrix, direction);
                        })
                      }
                    </tr>
                  ))
                })
              }

              </tbody>
            </StyledTable>
          }
        </Card>
      </StyledContent>
    )
  }
}

const mapStateToProps = (state) => ({
  categories: state.categories.categoriesList
})

export default connect(mapStateToProps, null)(TradeMatrix)




// WEBPACK FOOTER //
// ./src/components/view-trade-matrix/index.js